import { useState } from "react";
import { useTranslation } from "react-i18next";
import { ClipboardDocumentCheckIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { EnhancedChecklistSelector } from "./enhanced-checklist-selector";

export default function ReportChecklistTemplateField({ value, selected, onChange, disabled, label }) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  return <div className="space-y-2">
    <span className="block text-sm font-medium text-slate-700">{label || t("Checklist")}</span>
    <div className="flex gap-2">
      <button type="button" disabled={disabled} aria-haspopup="dialog" aria-expanded={open} onClick={() => setOpen(true)} className="flex min-h-[44px] min-w-0 flex-1 items-center gap-3 rounded-xl border border-slate-300 bg-white px-3 py-2.5 text-left text-sm hover:bg-slate-50 disabled:opacity-50">
        <ClipboardDocumentCheckIcon className="h-5 w-5 shrink-0 text-slate-400" />
        <span className="min-w-0 break-words">{value ? selected?.title || `#${value}` : t("reportWizard.noChecklist")}</span>
      </button>
      {value && <button type="button" disabled={disabled} aria-label={t("Remove")} className="rounded-xl border border-slate-300 px-3 text-slate-500 hover:bg-slate-50 disabled:opacity-50" onClick={() => onChange(null)}><XMarkIcon className="h-4 w-4" /></button>}
    </div>
    {open && !disabled && <EnhancedChecklistSelector open typeOnly initialType={selected} showEmptyOption={false} onClose={() => setOpen(false)} onSelect={(config) => {
      if (disabled || !config.checklist_type_id) return;
      onChange({ id: config.checklist_type_id, title: config.checklist_type_title });
    }} />}
  </div>;
}
